<template>
    <div class="page">
        <div class="page__bd">
            <article class="weui-article">
                <h1 style="text-align:center; font-weight: bold;">{{suggestion.title}}</h1>
                <div>
                    <h3 style="text-align:center;"><span class="suggestion-type">{{suggestion.typeStr}}</span> {{suggestion.user.realname?suggestion.user.realname:suggestion.user.nickname}} {{createTime}}</h3>
                </div>
                <section style="margin-top: 20px;">
                    <section>
                        <h2>1.1 反馈内容</h2>
                        <p>
                            {{suggestion.content}}
                        </p>
                    </section>
                    <section v-if="suggestion.pics.length>0">
                        <h2>1.2 图片说明</h2>
                        <p style="text-align: center;">
                            <img :src="pic" v-for="pic in suggestion.pics" :key="pic._id" alt="">
                        </p>
                    </section>
                </section>
            </article>
            <div class="reply">
                <div class="weui-cells__title">回复用户</div>
                <div class="weui-cells weui-cells_form">
                    <div class="weui-cell">
                        <div class="weui-cell__bd">
                            <textarea class="weui-textarea" v-model="content" placeholder="请输入回复的内容" rows="3"></textarea>
                            <div class="weui-textarea-counter">
                                <span>{{content.length}}</span>/256</div>
                        </div>
                    </div>
                </div>
                <div class="warehousing-footer-item" style="flex:2" @click="save">
                    <a href="javascript:;">提交回复</a>
                </div>
            </div>
        </div>

        <div class="weui-footer">
            <p class="weui-footer__links">
                <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
            </p>
            <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
        </div>
    </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      _id: "",
      suggestion: {
        user: {},
        pics: []
      },
      content: "",
      createTime: "",
      year: moment().format("YYYY")
    };
  },
  created() {
    this._id = this.$route.params.id;
    let encodeToken = this.$route.params.token;
    let token = decodeURIComponent(encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + token;

    axios
      .get("/api/suggestion/getById/" + this._id)
      .then(res => {
        if (res.data.success) {
          this.suggestion = res.data.data;
          if (this.suggestion.type == 1) {
            this.suggestion.typeStr = "系统出错";
          } else if (this.suggestion.type == 2) {
            this.suggestion.typeStr = "优化建议";
          } else if (this.suggestion.type == 3) {
            this.suggestion.typeStr = "其他";
          }
          this.createTime = moment(this.suggestion.createdAt).format(
            "YYYY-MM-DD HH:mm"
          );
        } else {
          weui.alert("获取意见反馈信息出错");
        }
      })
      .catch(err => {
        weui.alert("获取意见反馈信息出错");
      });
  },
  methods: {
    save() {
      if (this.content.length < 2) {
        weui.alert("回复内容不能少于2个字");
        return;
      } else {
        axios
          .post("/api/suggestion/reply/" + this._id, { content: this.content })
          .then(res => {
            if (res.data.success) {
              weui.toast("回复成功");
              this.content = "";
            } else {
              weui.alert(res.data.message);
            }
          })
          .catch(err => {
            weui.alert("回复失败");
          });
      }
    }
  }
};
</script>

<style scoped>
.suggestion-type {
  background-color: orangered;
  color: #ffffff;
  border-radius: 3px;
  padding: 2px 6px;
  font-size: 12px;
}
.weui-footer {
  margin-bottom: 20px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.reply {
  margin: 0px 15px 20px 15px;
}
.warehousing-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  background-color: #1aad19;
  margin-top: 10px;
  line-height: 50px;
}
.warehousing-footer-item a {
  color: #ffffff;
}
</style>





// WEBPACK FOOTER //
// src/components/operations/SuggestionDetail.vue